import { useEffect, useRef, useState } from "react";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import api from "../services/api";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import { Card, CardBody, CardTitle } from "reactstrap";
import { toast } from "react-toastify";

import "../styles/dataTable.css"
import searchIcon from '../assets/images/search_icon.svg'
import addIcon from '../assets/images/add-icon.svg'
import arrowIcon from '../assets/images/Arrow.svg'
import upwardArrowIcon from '../assets/images/upward_arrow.svg'
import editIcon from '../assets/images/edit_icon.svg'
import CreateUpdateSubPage from "./CreateUpdateSubPage";
import gsap from "gsap";

const ManageSubPage = () => {
  const [pages, setPages] = useState([]);
  const [subPages, setSubpages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPage, setSelectedPage] = useState('');
  const [subPageName, setSubPageName] = useState('');
  const [subPageId, setSubPageId] = useState(null);
  const [errors, setErrors] = useState({});

  const [showCreatePage, setShowCreatePage] = useState(false);
  const containerRef = useRef(null);

  // Table
      const [search, setSearch] = useState("");
      const [entriesPerPage, setEntriesPerPage] = useState(10);
      const [currentPage, setCurrentPage] = useState(1);
      const [sortField, setSortField] = useState(null);
      const [sortOrder, setSortOrder] = useState("asc");
    
      const filteredData = subPages.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    
      if (sortField) {
        filteredData.sort((a, b) => {
          const valA = a[sortField];
          const valB = b[sortField];
          if (typeof valA === "number") {
            return sortOrder === "asc" ? valA - valB : valB - valA;
          } else {
            return sortOrder === "asc"
              ? valA.localeCompare(valB)
              : valB.localeCompare(valA);
          }
        });
      }
    
      const totalPages = Math.ceil(filteredData.length / entriesPerPage);
      const paginatedData = filteredData.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
      );
    
      useEffect(() => {
        if (currentPage > totalPages) setCurrentPage(1);
      }, [search, entriesPerPage, totalPages]);
    
      // Sort Toggle Handler
      const handleSort = (field) => {
        if (sortField === field) {
          setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
          setSortField(field);
          setSortOrder("asc");
        }
      };

  useEffect(() => {
    fetchPages();
    fetchSubpages();
  }, [showCreatePage]);

  useEffect(() => {
    if (subPages.length) {
      $('#subPageTable').DataTable();
    }
  }, [subPages]);

  const fetchPages = async () => {
    try {
      const response = await api.get('/page/get-all');
      setPages(response.data.data);
    } catch (error) {
      console.error('Error fetching pages:', error);
    }
  };

  const fetchSubpages = async () => {
    try {
      const response = await api.get('/subpageapi/get-all-admin');
      setSubpages(response.data.data);
    } catch (error) {
      console.error('Error fetching subpage data:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!selectedPage) errors.selectedPage = 'select page';
    if (!subPageName.trim()) errors.subPageName = 'subpage name cannot be empty';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});

    const formData = new FormData();
    formData.append('page_id', selectedPage);
    formData.append('subpage', subPageName);

    try {

      if (subPageId) {
        const response = await api.post(`/subpageapi/update/${subPageId}`, formData);
        if (response.data.status === "success") {
          toast.success('Subpage updated successfully!');
          setSubPageId(null);
          handleEdit();

        } else {
          toast.error('Failed to update subpage');
        }
      } else {
        const response = await api.post('/subpageapi/add', formData);

        if (response.data.status === "success") {
          toast.success(`Subpage created successfully!`);
        } else {
          toast.error('Failed to create subpage');
        }
      }
      setSelectedPage('');
      setSubPageName('');
      handleEdit();
      fetchSubpages();
    } catch (error) {
      console.error('Error saving subpage:', error);
      toast.error('Error saving subpage');
    }
  };

  const handleEdit = (subPage) => {
    setSubPageId(subPage.id);
    setSelectedPage(subPage.page_id);
    setSubPageName(subPage.subpage);
    setShowCreatePage(true);
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/subpages/${id}`);
      setSubpages(subPages.filter(subpage => subpage.id !== id));
      toast.success(`Subpage with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting subpage:', error);
      toast.error('Error deleting subpage');
    }
  };

  const togglesubPageStatus = async (id, isActive) => {
          try {
            if (isActive) {
              await api.post(`/subpageapi/isactive/${id}`,{
                is_active : 0
              });
            } else {
              await api.post(`/subpageapi/isactive/${id}`,{
                is_active : 1
              });
            }
            fetchSubpages();
          } catch (error) {
            console.error('Error updating pages status:', error);
            alert('Error updating pages status');
          }
        };

  useEffect(() => {
        if (showCreatePage && containerRef.current) {
          gsap.fromTo(
            containerRef.current,
            { autoAlpha: 0, y: 50 },
            { autoAlpha: 1, y: 0, duration: 0.5, ease: "power2.out" }
          );
        }
      }, [showCreatePage]);

  return (
    <div style={{position: 'relative'}}>
      <div style={{ padding: "20px", opacity: showCreatePage ? 0.5 : 1 ,pointerEvents: showCreatePage ? 'none' : "auto" }}>
        

        {/* Table */}
          {/* Table Header */}
        <div className="table-header">
              <h2 style={{fontWeight: 700,}}>Manage Subpage</h2>

              <div className="search-container">
                  <input
                  type="text"
                  value={search}
                  onChange={(e) => {
                      setSearch(e.target.value);
                      setCurrentPage(1);
                  }}
                  placeholder="search"
                  />
                  <img src={searchIcon} alt="search-icon" className="search-icon" />
              </div>

              <div className="entries-container">
                  <label htmlFor="noOfEntries">Show: </label>
                  <select
                      value={entriesPerPage}
                      id="noOfEntries"
                      onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  >
                      <option value={10}>10 Entries per page </option>
                      <option value={50}>50 Entries per page</option>
                      <option value={100}>100 Entries per page</option>
                  </select>
              
              </div>

              <div className="action-btn">
                  <button onClick={() => {
                            setSubPageId(null);
                            setSelectedPage('');
                            setSubPageName('');
                            setShowCreatePage(true);
                            setErrors({});
                      }}>
                    <img src={addIcon} alt="add-icon" />  Add Subpage
                  </button>
              </div>

          </div>

            {/* Table */}
              <table width="100%" cellPadding="26" className="table-no-outer-border">
                <thead>
                  <tr>
                    <th>
                      Sr. No. 
                    </th>
                    <th onClick={() => handleSort("name")}>
                      <div className='name-container'>
                        Page Name 
                        <div className='sort-arrow-container'>
                          <img src={upwardArrowIcon} alt="upward-arrow"
                            style={ {opacity: sortField === "name" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                          />
                          <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                            opacity: sortField === "name" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                          }} />
                        </div>
                      </div>
                    </th>
                    <th onClick={() => handleSort("subpage")}>
                      <div className='name-container'>
                        Subpage Name 
                        <div className='sort-arrow-container'>
                          <img src={upwardArrowIcon} alt="upward-arrow"
                            style={ {opacity: sortField === "subpage" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                          />
                          <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                            opacity: sortField === "subpage" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                          }} />
                        </div>
                      </div>
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((row, i) => {
                      const srNo = (currentPage - 1) * entriesPerPage + i + 1;
                      return(
                        <tr key={row.id}>
                          <td>{srNo}</td>
                          <td>{pages.filter(el => el.id === row.page_id)[0]?.name}</td>
                          <td>{row.subpage}</td>
                          <td className='text-center align-middle'>
                            <div className="custom-toggle-switch">
                              <input
                                type="checkbox"
                                className="custom-toggle-input"
                                checked={row.is_active === "1"}
                                onChange={() => togglesubPageStatus(row.id, row.is_active === "1")}
                                id={`toggle-${row.id}`}
                              />
                              <label className="custom-toggle-label" htmlFor={`toggle-${row.id}`}>
                                <span className="custom-toggle-text">
                                  {row.is_active === "1" ? 'Active' : 'Inactive'}
                                </span>
                              </label>
                            </div>
                          </td>
                          <td className='text-center align-middle'>
                            
                              {/* <FaTrash style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(row.id)} /> */}

                              <button className='edit-button' onClick={() => handleEdit(row)}>
                                <img src={editIcon} alt="editIcon" />
                                Edit
                              </button>
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center" }}>
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              <div>

              </div>
                <div style={{paddingBottom: '30px', background: '#fff'}}>
                  <div style={{ padding: "30px", textAlign: "center", borderTop: '2px solid #F2F2F2',borderBottom: '2px solid #F2F2F2'}}>
                    {/* Prev arrow */}
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        style={{
                        margin: "0 5px",
                        padding: "5px 10px",
                        background: "#fff",
                        border: "none",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        color: currentPage === 1 ? "#ccc" : "#000"
                        }}
                    >
                      <img src={arrowIcon} alt="arrow-icon"
                        style={{
                          opacity: currentPage === 1 ? "0.5" : "1",
                        }}
                      />

                    </button>

                    {/* Page Numbers */}
                    {(() => {
                        const pageButtons = [];
                        const maxVisiblePages = 4;

                        if (totalPages <= maxVisiblePages + 1) {
                        // Show all pages if total pages is small
                        for (let i = 1; i <= totalPages; i++) {
                            pageButtons.push(i);
                        }
                        } else {
                        if (currentPage <= maxVisiblePages) {
                            // Show first 4 pages and last
                            for (let i = 1; i <= maxVisiblePages; i++) {
                            pageButtons.push(i);
                            }
                            pageButtons.push('...', totalPages);
                        } else if (currentPage > totalPages - maxVisiblePages) {
                            // Show first, ..., last 4 pages
                            pageButtons.push(1, '...');
                            for (let i = totalPages - maxVisiblePages + 1; i <= totalPages; i++) {
                            pageButtons.push(i);
                            }
                        } else {
                            // Middle section: 1, ..., current-1, current, current+1, ..., last
                            pageButtons.push(1, '...');
                            pageButtons.push(currentPage - 1, currentPage, currentPage + 1);
                            pageButtons.push('...', totalPages);
                        }
                        }

                        return pageButtons.map((page, index) => {
                        if (page === '...') {
                            return (
                            <span key={`ellipsis-${index}`} style={{ margin: "0 5px" }}>...</span>
                            );
                        }

                        return (
                            <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            style={{
                                margin: "0 5px",
                                padding: "5px 10px",
                                background: currentPage === page ? "#D9D9D9" : "#fff",
                                color: currentPage === page ? "black" : "#00000075",
                                border: "none",
                                cursor: "pointer",
                            }}
                            >
                            {page}
                            </button>
                        );
                        });
                    })()}

                    {/* Next arrow */}
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        style={{
                        margin: "0 5px",
                        padding: "5px 10px",
                        background: "#fff",
                        border: "none",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                        color: currentPage === totalPages ? "#ccc" : "#000"
                        }}
                    >
                        <img src={arrowIcon} alt="arrow-icon"
                          style={{
                            opacity: currentPage === totalPages ? "0.5" : "1",
                            transform: 'rotateY(180deg)'
                          }}
                        />
                    </button>
                  </div>
                </div>

              {/* Table */}

              

        {/* Table */}

        
      </div>

      {
        showCreatePage &&
        <CreateUpdateSubPage setShowCreatePage={setShowCreatePage} containerRef={containerRef} subPageId={subPageId} setSubPageId={setSubPageId}
          subPageName={subPageName}
          setSubPageName={setSubPageName}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          fetchSubpages={fetchSubpages}
          pages={pages}
        />
      }

    </div>
  );
};

export default ManageSubPage;
